const UidispatcherApiModule = await import("uidispatcher_api/UidispatcherApiModule");
export const FeatureSessionStore = UidispatcherApiModule.FeatureSessionStoreModule.default;
